var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositiveSentiment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3832 0 0 5.3832 0 12C0 18.6168 5.3832 24 12 24C18.6168 24 24 18.6168 24 12C24 5.3832 18.6168 0 12 0ZM12 21.8182C6.58625 21.8182 2.18182 17.4137 2.18182 12C2.18182 6.58625 6.58625 2.18182 12 2.18182C17.4137 2.18182 21.8182 6.58625 21.8182 12C21.8182 17.4137 17.4137 21.8182 12 21.8182Z",
    fill: "#00B200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9313 14.9313C13.3149 16.5476 10.6851 16.5476 9.06871 14.9313C8.64275 14.5053 7.95198 14.5053 7.52595 14.9313C7.09991 15.3574 7.09991 16.0481 7.52595 16.4741C8.75962 17.7078 10.3795 18.3244 12.0001 18.3244C13.6201 18.3244 15.2408 17.7075 16.4742 16.4741C16.9002 16.0481 16.9002 15.3574 16.4742 14.9313C16.0481 14.5052 15.3573 14.5053 14.9313 14.9313Z",
    fill: "#00B200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37381 10.7011C8.64508 10.4305 8.79999 10.0553 8.79999 9.67273C8.79999 9.29019 8.64508 8.91491 8.37381 8.64437C8.10326 8.37382 7.72799 8.21819 7.34545 8.21819C6.9621 8.21819 6.58763 8.37382 6.31701 8.64437C6.04581 8.91491 5.8909 9.29019 5.8909 9.67273C5.8909 10.0553 6.04581 10.4305 6.31701 10.7011C6.58763 10.9724 6.9629 11.1273 7.34545 11.1273C7.72799 11.1273 8.10326 10.9724 8.37381 10.7011Z",
    fill: "#00B200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6546 8.21819C16.272 8.21819 15.8967 8.37382 15.6261 8.64437C15.3556 8.91491 15.2 9.28946 15.2 9.67273C15.2 10.056 15.3556 10.4305 15.6261 10.7011C15.8967 10.9724 16.272 11.1273 16.6546 11.1273C17.0371 11.1273 17.4124 10.9724 17.6829 10.7011C17.9535 10.4305 18.1091 10.056 18.1091 9.67273C18.1091 9.29019 17.9534 8.91491 17.6829 8.64437C17.4124 8.37382 17.0371 8.21819 16.6546 8.21819Z",
    fill: "#00B200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveSentiment);
export default __webpack_public_path__ + "static/media/positiveSentiment.c9574b80f0f59f0efebea38e5c6abfd6.svg";
export { ForwardRef as ReactComponent };